import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faFilePdf, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import CreatePdfFilAnnuel from 'components/CreatePdfFilAnnuel';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

import { NotificationManager } from 'react-notifications';

import JsPDF from 'jspdf';

import axios from 'axios';

import { registerLocale } from "react-datepicker";
import fr from 'date-fns/locale/fr';

registerLocale('fr', fr);

export default function ClasseFilAnnuel({idClasse}) {

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [allSeance, setAllSeance] = useState([]);
    const [classInfo, setClassInfo] = useState(null);
    const [isExporting, setIsExporting] = useState(false);

    const setStartOfDay = () => {
        const startOfDay = new Date();
        startOfDay.setHours(0, 0, 0, 0); // Sets the time to 23:59:59.999
        setStartDate(startOfDay);
    };

    const setEndOfDay = () => {
        const endOfDay = new Date();
        endOfDay.setHours(23, 59, 59, 999); // Sets the time to 23:59:59.999
        setEndDate(endOfDay);
    };

    function uppercaseFirstChar(str) {
      if (!str) return str; // Return the original string if it's empty or undefined
      return str.charAt(0).toUpperCase() + str.slice(1);
    }

    React.useEffect(() => {
        setStartOfDay();
        setEndOfDay();
    }, []);

    React.useEffect(() => {
        let isMounted = true;
        setClassInfo(null);

        axios.get(`https://eps.acces-editions.com/api/getMyClasseId?id_classe=${idClasse}`)
            .then((response) => {
                if (isMounted && response.data && response.data[0]) setClassInfo(response.data[0]);
            })
            .catch(() => {});

        return () => {
            isMounted = false;
        };
    }, [idClasse]);

    function getFilAnnuel(idClasse, startDate, endDate) {
        const formData = new FormData();
        formData.append('id_classe', idClasse)
        formData.append('date_start', startDate)
        formData.append('date_end', endDate)

        axios.post('https://eps.acces-editions.com/api/filAnnuel', formData)
        .then((res) => {
            if(res.data.length > 0)
            {
                setAllSeance(res.data)
            } else {
                setAllSeance([])
                NotificationManager.error('Aucun fil pour ces dates !', '', 3000);
            }
        })
        .catch(() => {
            setAllSeance([])
            NotificationManager.error("Le fil annuel n'a pas pu être chargé", '', 3000);
        })
    }

    async function generatePDF() {
        if (isExporting) return;

        setIsExporting(true);
        try {
            if (!classInfo) {
                const response = await axios.get(`https://eps.acces-editions.com/api/getMyClasseId?id_classe=${idClasse}`);
                if (!response.data || !response.data[0]) throw new Error('Class information unavailable');
                setClassInfo(response.data[0]);

                await new Promise((resolve) => {
                    window.requestAnimationFrame(() => window.requestAnimationFrame(resolve));
                });
            }

            const source = document.querySelector('#fil_annuel');
            if (!source) throw new Error('PDF source unavailable');

            const report = new JsPDF('p', 'pt', 'a4');
            await report.html(source, {
                x: 30,
                y: 28,
                width: 535,
                windowWidth: 760,
                autoPaging: 'text',
                html2canvas: {
                    useCORS: true,
                    backgroundColor: '#ffffff',
                },
            });
            report.save(`fil-annuel-classe-${idClasse}.pdf`);
        } catch (error) {
            NotificationManager.error("Le PDF n'a pas pu être généré", '', 3000);
        } finally {
            setIsExporting(false);
        }
    }

    return (
        <>
            {allSeance.length > 0 && (
                <CreatePdfFilAnnuel idClasse={idClasse} classInfo={classInfo} allSeance={allSeance} startDate={startDate} endDate={endDate} />
            )}

            <section className="ae-workspace-card ae-workspace-card--calendar">
                <header className="ae-workspace-card-header">
                    <span className="ae-workspace-card-icon"><FontAwesomeIcon icon={faCalendarDays} /></span>
                    <div>
                        <h2>Synthèse annuelle</h2>
                        <p>Disciplines abordées pour lesquelles au moins une activité a été évaluée.</p>
                    </div>
                </header>

                <div className="ae-workspace-card-body">
                    <div className="ae-workspace-date-filters">
                        <div className="ae-workspace-field">
                            <label htmlFor="annual-start-date">Date de début</label>
                            <div className="ae-workspace-date-input">
                                <DatePicker id="annual-start-date" locale="fr" selected={startDate} onChange={(date) => setStartDate(date)} dateFormat="dd/MM/yyyy" />
                                <FontAwesomeIcon icon={faCalendarDays} />
                            </div>
                        </div>
                        <div className="ae-workspace-field">
                            <label htmlFor="annual-end-date">Date de fin</label>
                            <div className="ae-workspace-date-input">
                                <DatePicker id="annual-end-date" locale="fr" selected={endDate} onChange={(date) => setEndDate(date)} dateFormat="dd/MM/yyyy" />
                                <FontAwesomeIcon icon={faCalendarDays} />
                            </div>
                        </div>
                        <button type="button" className="ae-workspace-primary-button" onClick={() => getFilAnnuel(idClasse, startDate, endDate)}>
                            <FontAwesomeIcon icon={faMagnifyingGlass} />
                            <span>Afficher</span>
                        </button>
                        {allSeance.length > 0 && (
                            <button type="button" className="ae-workspace-secondary-button" disabled={isExporting} onClick={(e) => {e.preventDefault(); generatePDF()}}>
                                <FontAwesomeIcon icon={faFilePdf} />
                                <span>{isExporting ? 'Génération…' : 'Exporter en PDF'}</span>
                            </button>
                        )}
                    </div>

                    {allSeance.length > 0 ? (
                        <div className="ae-workspace-table-wrap">
                            <table className="ae-workspace-table">
                                <thead>
                                    <tr>
                                        <th>Cycle</th>
                                        <th>Champ d'apprentissage</th>
                                        <th>Discipline</th>
                                        <th>Activités évaluées</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {allSeance.map((row, index) => (
                                        <tr key={`${row.id_cycle}-${row.nom_sequence}-${index}`}>
                                            <td data-label="Cycle"><strong>Cycle {row.id_cycle}</strong></td>
                                            <td data-label="Champ d'apprentissage">{uppercaseFirstChar(row.nom_competence)}</td>
                                            <td data-label="Discipline">{row.nom_sequence}</td>
                                            <td data-label="Activités évaluées"><span className="ae-workspace-count-badge">{row.nbSeance}</span></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="ae-workspace-empty">Choisissez une période puis affichez le fil annuel de la classe.</p>
                    )}
                </div>
            </section>
        </>
    );
}
